import { FormControlsModule } from './../../shared/form-controls/form-controls.module';
import { DialogDraggableHeaderModule } from './../../shared/dialog-draggable-header/dialog-draggable-header.module';
import { SearchableAutocompleteModule } from './../../shared/searchable-autocomplete/searchable-autocomplete.module';
import { TreeModule } from 'primeng/tree';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

// Prime Ng Imports
import { TableModule } from 'primeng/table';
import { MultiSelectModule as PrimengMultiSelectModule } from 'primeng/multiselect';
import { FileUploadModule } from 'primeng/fileupload';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { CgpModule } from '../../cgp.module';
import { TprecmComponent } from './tprecm.component';
import { ViewUpdateTprComponent } from './tpr/view-update-tpr.component';
import { TprDuplicateDialogComponent } from './tpr/tpr-dialogs/tpr-duplicate/tpr-duplicate-dialog.component';
import { TprDuplicateRevDialogComponent } from './tpr/tpr-dialogs/tpr-duplicate-rev/tpr-duplicate-rev-dialog.component';
import { TprGeneralInfoComponent } from './tpr/tpr-tab-group/tpr-general-info-tab/tpr-general-info.component';
import { TprProcessKitComponent } from './tpr/tpr-tab-group/tpr-process-kit-tab/tpr-process-kit.component';
import { TprDesignProgressComponent } from './tpr/tpr-tab-group/tpr-design-progress-tab/tpr-design-progress.component';
import { TprBuildProgressComponent } from './tpr/tpr-tab-group/tpr-build-progress-tab/tpr-build-progress.component';
import { TprSummaryComponent } from './tpr/tpr-tab-group/tpr-summary-tab/tpr-summary.component';
import { TprecmService } from './tprecm.service';
import { ToastrModule } from 'ngx-toastr';
import { ViewUpdateTprService } from './tpr/view-update-tpr.service';
import { SourceMaintenanceModalService } from '../tprecm/table-maintenance/source-maintenance-modal/source-maintenance-modal.service';
import { AddSourceModalService } from '../tprecm/table-maintenance/source-maintenance-modal/add-source/add-source-modal.service';
import { AddSpanModalService } from '../tprecm/administration/span-maintenance-modal/add-span/add-span-modal.service';
import { AddReasonCodeModalService } from '../tprecm/administration/reason-code-maintenance-modal/add-reason-code/add-reason-code-modal.service';
import { SourceMaintenanceModalComponent } from '../tprecm/table-maintenance/source-maintenance-modal/source-maintenance-modal.component';
import { AddSourceModalComponent } from '../tprecm/table-maintenance/source-maintenance-modal/add-source/add-source-modal.component';
import { ReasonCodeMaintenanceModalService } from '../tprecm/administration/reason-code-maintenance-modal/reason-code-maintenance-modal.service';
import { ReasonCodeMaintenanceModalComponent } from '../tprecm/administration/reason-code-maintenance-modal/reason-code-maintenance-modal.component';
import { AddReasonCodeModalComponent } from '../tprecm/administration/reason-code-maintenance-modal/add-reason-code/add-reason-code-modal.component';
import { SpanMaintenanceModalService } from '../tprecm/administration/span-maintenance-modal/span-maintenance-modal.service';
import { SpanMaintenanceModalComponent } from '../tprecm/administration/span-maintenance-modal/span-maintenance-modal.component';
import { AddSpanModalComponent } from '../tprecm/administration/span-maintenance-modal/add-span/add-span-modal.component';
import { UserMaintenanceModalService } from '../tprecm/administration/user-maintenance-modal/user-maintenance-modal.service';
import { UserMaintenanceModalComponent } from '../tprecm/administration/user-maintenance-modal/user-maintenance-modal.component';
import { AddUserModalComponent } from '../tprecm/administration/user-maintenance-modal/add-user/add-user-modal.component';
import { AddUserModalService } from '../tprecm/administration/user-maintenance-modal/add-user/add-user-modal.service';
import { DataTableModule } from '../../shared/data-table/data-table.module';
import { ProgramMaintenanceComponent } from './table-maintenance/program-maintenance/program-maintenance.component';
import { TprCommentModalComponent } from './tpr/tpr-dialogs/tpr-comment/tpr-comment-modal.component';
import { TprCommentApiService } from './tpr/tpr-dialogs/tpr-comment/tpr-comment-modal.service';
import { TprAddModalComponent } from './tpr/tpr-dialogs/tpr-add/tpr-add-modal.component';
import { TprReasonsApiService } from './tpr/tpr-dialogs/tpr-reasons/tpr-reasons-modal.service';
import { TprReasonModalComponent } from './tpr/tpr-dialogs/tpr-reasons/tpr-reasons-modal.component';
import { TprNecModalComponent } from './tpr/tpr-dialogs/tpr-nec/tpr-nec-modal.component';
import { TprNecApiService } from './tpr/tpr-dialogs/tpr-nec/tpr-nec-modal.service';
import { TprFilesApiService } from './tpr/tpr-dialogs/tpr-files/tpr-show-files-modal.service';
import { TprShowFilesModalComponent } from './tpr/tpr-dialogs/tpr-files/tpr-show-files-modal.component';
import { TprAddFilesModalComponent } from './tpr/tpr-dialogs/tpr-files/tpr-add-files/tpr-add-files-modal.component';
import { EcmComponent } from './ecm/ecm.component';
import { EcmModule } from './ecm/ecm.module';
import { TprecmRoutes } from './tprecm.routing';
import { Route } from '@angular/router';
import { FileUploadSummaryComponent } from './reporting/file-upload-summary/file-upload-summary.component';
import { FileUploadSummaryModalService } from './reporting/file-upload-summary/file-upload-summary-modal.service';
import { FileUploadSummaryService } from './reporting/file-upload-summary/file-upload-summary.service';
import { TprEmailFilesComponent } from './tpr/tpr-dialogs/tpr-files/tpr-email-files/tpr-email-files.component';
import { ProgramToolFrontLoaderComponent } from './table-maintenance/program-maintenance/program-tool-front-loader/program-tool-front-loader.component';
import { AddProgramModalComponent } from './table-maintenance/program-maintenance/add-program-modal/add-program-modal.component';
import { LoadingSpinnerModule } from 'src/app/shared/loading-spinner/loading-spinner.module';
import { UserManageRequestAccessComponent } from './administration/user-maintenance-modal/user-manage-request-access/user-manage-request-access.component';
import { TprecmAuthorizationService } from './authorization/tprecm-authorization.service';
import { RequestAccessFormComponent } from './request-access-form/request-access-form.component';
import { FeaturePermissionDirective } from './authorization/directives/feature-permission.directive';
import { SubFeaturePermissionDirective } from './authorization/directives/sub-feature-permission.directive';
import { TprAddReasonComponent } from './tpr/tpr-dialogs/tpr-reasons/tpr-add-reason/tpr-add-reason.component';
import { TprAddCommentComponent } from './tpr/tpr-dialogs/tpr-comment/tpr-add-comment/tpr-add-comment.component';
import { FeaturePermissionAnyDirective } from './authorization/directives/feature-permission-any.directive';
import { FeaturePermissionAllDirective } from './authorization/directives/feature-permission-all.directive';
import { FeaturePermissionNoneDirective } from './authorization/directives/feature-permission-none.directive';
import { TprDeleteComponent } from './tpr/tpr-dialogs/tpr-delete/tpr-delete.component';
import { TprNecCompleteDateComponent } from './tpr/tpr-dialogs/tpr-nec/tpr-nec-complete-date/tpr-nec-complete-date.component';
import { BatchJobMaintenanceModalComponent } from './administration/batch-job-maintenance-modal/batch-job-maintenance-modal.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ChangeLogModalComponent } from './administration/change-log-modal/change-log-modal.component';
import { BuildDesignWeightModalComponent } from './administration/build-design-weight-modal/build-design-weight-modal.component';
import { BuildDesignWeightAddModalComponent } from './administration/build-design-weight-modal/build-design-weight-add-modal/build-design-weight-add-modal.component';
import { ChangeLogAddModalComponent } from './administration/change-log-modal/change-log-add-modal/change-log-add-modal.component';
import { ReportMetricsComponent } from './reporting/report-metrics/report-metrics.component';

export const tprecmRoutes: Route = {
   path: TprecmRoutes.TPRECM,
   component: TprecmComponent,
   children: [
      { path: `${TprecmRoutes.VIEW_UPDATE_TPR}/${TprecmRoutes.INACTIVE}`, component: ViewUpdateTprComponent },
      { path: `${TprecmRoutes.VIEW_UPDATE_TPR}/${TprecmRoutes.RE_SOURCE}`, component: ViewUpdateTprComponent },
      { path: TprecmRoutes.VIEW_UPDATE_TPR, component: ViewUpdateTprComponent },
      { path: `${TprecmRoutes.VIEW_UPDATE_TPR}/:id`, component: ViewUpdateTprComponent },
      { path: TprecmRoutes.ECM, component: EcmComponent },
      { path: `${TprecmRoutes.ECM}/${TprecmRoutes.RE_SOURCE}`, component: EcmComponent },
      { path: `${TprecmRoutes.REPORTS}/${TprecmRoutes.METRICS}`, component: ReportMetricsComponent }
   ]
};

@NgModule({
    imports: [
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatGridListModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatButtonModule,
        MatMenuModule,
        MatListModule,
        MatSidenavModule,
        ToastrModule.forRoot(),
        MatDialogModule,
        MatTabsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTooltipModule,
        TableModule,
        PrimengMultiSelectModule,
        FileUploadModule,
        CgpModule,
        DataTableModule,
        HttpClientModule,
        EcmModule,
        TreeModule,
        MatCardModule,
        LoadingSpinnerModule,
        SearchableAutocompleteModule,
        MatRadioModule,
        DialogDraggableHeaderModule,
        FormControlsModule,
        ProgressSpinnerModule,
        OverlayPanelModule
    ],
    declarations: [
        TprecmComponent,
        ViewUpdateTprComponent,
        TprGeneralInfoComponent,
        TprCommentModalComponent,
        TprNecModalComponent,
        TprReasonModalComponent,
        TprAddReasonComponent,
        TprShowFilesModalComponent,
        TprAddFilesModalComponent,
        TprProcessKitComponent,
        TprDesignProgressComponent,
        TprSummaryComponent,
        TprBuildProgressComponent,
        TprDuplicateDialogComponent,
        TprDuplicateRevDialogComponent,
        TprAddModalComponent,
        SourceMaintenanceModalComponent,
        AddSourceModalComponent,
        AddSpanModalComponent,
        AddReasonCodeModalComponent,
        ReasonCodeMaintenanceModalComponent,
        SpanMaintenanceModalComponent,
        AddUserModalComponent,
        UserMaintenanceModalComponent,
        ProgramMaintenanceComponent,
        FileUploadSummaryComponent,
        TprEmailFilesComponent,
        ProgramToolFrontLoaderComponent,
        AddProgramModalComponent,
        UserManageRequestAccessComponent,
        RequestAccessFormComponent,
        FeaturePermissionDirective,
        SubFeaturePermissionDirective,
        TprAddCommentComponent,
        FeaturePermissionAnyDirective,
        FeaturePermissionAllDirective,
        FeaturePermissionNoneDirective,
        TprDeleteComponent,
        TprNecCompleteDateComponent,
        BatchJobMaintenanceModalComponent,
        ChangeLogModalComponent,
        BuildDesignWeightModalComponent,
        BuildDesignWeightAddModalComponent,
        ChangeLogAddModalComponent,
        ReportMetricsComponent
    ],
    providers: [
        TprecmService,
        TprecmAuthorizationService,
        SourceMaintenanceModalService,
        AddSourceModalService,
        AddSpanModalService,
        AddReasonCodeModalService,
        AddUserModalService,
        TprFilesApiService,
        ReasonCodeMaintenanceModalService,
        SpanMaintenanceModalService,
        UserMaintenanceModalService,
        TprCommentApiService,
        TprReasonsApiService,
        TprNecApiService,
        ViewUpdateTprService,
        FileUploadSummaryModalService,
        FileUploadSummaryService
    ],
    exports: [
        TprecmComponent,
        ViewUpdateTprComponent,
        TprDuplicateDialogComponent,
        TprDuplicateRevDialogComponent,
        TprAddModalComponent,
        TprCommentModalComponent,
        TprReasonModalComponent,
        TprNecModalComponent,
        TprShowFilesModalComponent,
        TprAddFilesModalComponent,
        SourceMaintenanceModalComponent,
        AddSourceModalComponent,
        AddSpanModalComponent,
        AddReasonCodeModalComponent,
        ReasonCodeMaintenanceModalComponent,
        SpanMaintenanceModalComponent,
        AddUserModalComponent,
        UserMaintenanceModalComponent,
        BatchJobMaintenanceModalComponent,
        ReportMetricsComponent
    ]
})
export class TprecmModule { }
